import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const usePopperStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        list: {
            maxWidth: 500,
            maxHeight: 220,
            minWidth: 150,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "10px",
                height: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#808080",
                borderRadius: "5px",
                backgroundClip: "padding-box",
                border: "2px solid transparent",
            },
            "&::-webkit-scrollbar-track": {
                background: "#e0e0e0",
                borderLeft: "3px solid #f6f6f6",
                borderRight: "3px solid #f6f6f6",
                borderRadius: "5px",
            },
        },
        demo: {
            backgroundColor: theme.palette.background.paper,
        },
        title: {
            margin: theme.spacing(4, 0, 2),
        },
        calendar: {
            border: "none !important",
        },
        input: {
            display: "flex",
            padding: "5px",
            WebkitAppearance: "none",
            flexWrap: "wrap",
            borderRadius: "0.2rem",
            "&:focus": {
                borderColor: "cornflowerblue",
                outline: "none",
            },
        },
        inputProp: {
            fontSize: "14px",
            fontFamily: "Gilroy Regular",
            color: "#565656",
            flexWrap: "wrap",
        },
    })
);